import styled from 'styled-components';

export const StyledWebhooksHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin: 10px;

    .segmented-container{
        flex: 4;
    }

    .quick-links-container{
        flex: 1;
        justify-content: flex-end;
    }

    .ant-segmented{
        width: 800px;
        background-color: inherit;
    }

    .ant-segmented-item{
        padding: 10px 0;
    }

    .label-container{
    }
`;

export const StyledDisabledField = styled.div`
    color: #aaa;
`;

export const StyledWrapper = styled.div`
    form{
        max-width: 900px;
    }
`;

export const StyledWebhooksContainer = styled.div`
    display: flex;
    margin: 10px;
    flex-direction: column;
`;

export const StyledWebhookFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px;
    background-color: #fff;
    padding: 20px;

    .ant-input::placeholder {
        color: #999999;
        opacity: 0.7;
        font-style: italic;
    }
`;

export const StyledErrorStatus = styled.div`
`;

export const StyledStandardFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px;
    background-color: #fff;
    padding: 20px;
    align-items: center;
    justify-content: center;
    background-color: #f6f6f6;

    .standard-field-row{
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;
        flex-wrap: nowrap;

        .ant-form-item{
            width: 100%;
        }
    }
`;

export const StyledInlineElements = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    align-items: center;
    justify-content: flex-start;

    .ant-form-item{
        margin: 0;
        padding: 0;
        width: 100%;
    }
`;

export const StyledAuthFields = styled.div`
    width: 100%;
    padding-left: 150px;

    .ant-radio-group{
        width: 100%;
    }
`;

export const StyledField = styled.div`
    margin-bottom: 24px;
    width: 100%;
    padding-right: 10px;
`;